import * as React from "react";

/** Presentation/UI */
import { Col, CardText, CardBody, CardImg } from "reactstrap";
import Card from "../../Components/Styled/Card";
import Row from "../../Components/Styled/Row";
import BackendWrapper from "../../Components/Layouts/BackendWrapper";
import images from "src/Themes/Images";
import StyledButton from "../../Components/Styled/Button";
import Link from "../../Components/Styled/Link";
import colors from "src/Themes/Colors";
// import styled from "styled-components";

// const Label = styled.label`
//   padding: 2px;
//   background: ${colors.primary};
//   display: block;
// `;

const AboutRoots = () => {
  return (
    <BackendWrapper>
      <Row>
        <Row>
          <Col sm={12} md={4} lg={4}>
            <Card height={"100%"} padding={"0px"}>
              <CardImg height={"100%"} src={images.placeHolder} />
            </Card>
          </Col>
          <Col sm={12} md={8} lg={8}>
            <Card height={"100%"}>
              <CardBody>
                <h4>About Roots</h4>
                {/* TODO: Replace this with roots about us copy */}
                <CardText>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                  sit amet molestie tortor. Cras nec felis vel eros porta congue
                  vel at nunc. Morbi ultrices est a eleifend iaculis. Mauris sit
                  amet purus sed metus dignissim venenatis. Phasellus sit amet
                  pretium justo, in pellentesque eros. Nam eu turpis porta odio
                  malesuada semper ac nec sapien. Nam et ipsum at dolor ornare
                  aliquet facilisis quis risus. Nulla sit amet venenatis diam, a
                  suscipit dui. Integer rutrum nibh in velit vestibulum, et
                  dapibus libero blandit. Suspendisse ac erat commodo, consequat
                  arcu sit amet, accumsan nisl. Curabitur sed egestas eros, in
                  sagittis risus. Praesent at lorem sapien. Morbi nec ultricies
                  justo, gravida ornare quam. Sed sed sagittis elit.
                </CardText>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row paddingTop={"20"}>
          <Col sm={12} md={12} lg={12}>
            <Card>
              <CardBody>
                <p style={{ fontSize: "15px" }}>Roots Report</p>
                {/* TODO: replace this with reports description */}
                <CardText>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
                  sit amet molestie tortor. Cras nec felis vel eros porta congue
                  vel at nunc. Morbi ultrices est a eleifend iaculis. Mauris sit
                  amet purus sed metus dignissim venenatis. Phasellus sit amet
                  pretium justo, in pellentesque eros. Nam eu turpis porta odio
                  malesuada semper ac nec sapien. Nam et ipsum at dolor ornare
                  aliquet facilisis quis risus. Nulla sit amet venenatis diam, a
                  suscipit dui. Integer rutrum nibh in velit vestibulum, et
                  dapibus libero blandit. Suspendisse ac erat commodo, consequat
                  arcu sit amet, accumsan nisl. Curabitur sed egestas eros, in
                  sagittis risus. Praesent at lorem sapien. Morbi nec ultricies
                  justo, gravida ornare quam. Sed sed sagittis elit.
                  <br />
                  Morbi mattis, sapien aliquet porta luctus, urna eros pulvinar
                  dui, a vehicula risus leo a purus. Ut placerat non odio id
                  semper. Duis aliquam enim et facilisis dignissim. Fusce vitae
                  ipsum augue. Cras posuere ex non mi tristique, vulputate
                  pharetra orci euismod. Vivamus ut felis malesuada, tempor est
                  eget, convallis turpis. Donec ac nibh id augue volutpat
                  consectetur. Maecenas ultrices odio ac nulla tristique
                  imperdiet. Donec at augue volutpat, tristique massa ac,
                  ultricies nulla. Mauris varius quis eros vitae ultricies.
                  Donec tincidunt, erat quis pretium vestibulum, enim est
                  gravida orci, non porta nisl nunc sit amet ipsum. Fusce eu dui
                  nec sem sodales pellentesque a id libero. Curabitur consequat
                  et sapien in placerat. Maecenas eleifend felis massa, ac
                  iaculis elit venenatis eu. Proin ac dui ullamcorper, vehicula
                  ante vitae, venenatis massa. Class aptent taciti sociosqu ad
                  litora torquent per conubia nostra, per inceptos himenaeos.
                </CardText>
                {/* TODO: replace with download link for sample report */}
                <Link
                  to={{
                    pathname: `#`
                  }}
                  label={
                    <StyledButton
                      type="button"
                      label="Download Sample report"
                      width="200px"
                      color={colors.snow}
                      background={colors.default}
                      margin="5px"
                    />
                  }
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Row>
    </BackendWrapper>
  );
};

export default AboutRoots;



// WEBPACK FOOTER //
// ./src/Containers/AboutRoots/index.tsx